import {DateInput} from "./DateInput";
import React from "react";

export const NextPaymentOnOrAfterInput = (props: {onChange: any, error: boolean}) => {
    const  {onChange, error} = props
    const handleChange = (pickerData: any) => {
        if (Object.keys(pickerData).length === 0) {
            onChange(null, true)
        } else {
            onChange(pickerData.format('YYYY-MM-DD'), false)
        }
    }
    return (
        <DateInput label="Future Payments Start Date" name="next_payment_on_or_after"
                   onChange={handleChange}
                   error={error}
                   defaultValue={null}
        />
    )
}